import axios, { AxiosRequestConfig } from "axios";
import { getConfig } from "../config";
interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  _refreshAPI?: boolean; // Optional property
}

export const addInterceptors = () => {
  // Add a request interceptor
  axios.interceptors.request.use(
    function (config) {
      config.baseURL = `${getConfig().BASE_URL_API}/api`;
      config.withCredentials = true;

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 403) {
        // Add _retry flag to the refresh token request
        const refreshTokenRequest: CustomAxiosRequestConfig = {
          method: "post",
          url: `${getConfig().BASE_URL_API}/api/auth/logout`,
        };

        return axios(refreshTokenRequest)
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            if (window.location.pathname !== "/login") {
              window.location.href = "/login";
            }
          });
      }
      return Promise.reject(error);
    }
  );
};
